import { useQuery } from "react-query";
import { apiListEmployeesBotAvailability } from "../../../../../api/employee/apiListEmployeesBotAvailability";

export default function useEmployeesBotAvailabilityQuery(
  employeeIds: string[],
  enabled = true
) {
  return useQuery(
    ["employees_bot_availability", employeeIds.join("_")],
    async () => {
      const res = await apiListEmployeesBotAvailability(employeeIds);

      return res;
    },
    {
      enabled,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
}
